import React from 'react'
import R from '../ramda'
import { Col, Grid, Row } from '../react-bootstrap'
import U from '../Utils'
import FilterDescr from './FilterDescr'
import './Filters.css'
import MenuFilter from './MenuFilter'
import ToggleFilter from './ToggleFilter'
import YearFilter from './YearFilter'

function Filters(props) {
  const { filters, filterDescr, makeDictUrl, onUpdate, isSingleSelect, yearBounds } = props

  return (
    <Grid className="Filters">
      <Row>
        <Col sm={12}>
          <FilterDescr
            filterDescr={filterDescr}
            onClearFilter={(name) => U.clear_filters(onUpdate, [name])}
            onClearFilters={() => U.clear_filters(onUpdate, ['prof', 'terr', 'sett', 'contr'])}
          />
        </Col>
      </Row>

      <Row>
        <Col md={9} className="filtri-btn">
          <Row className="Filters-menu">
            <Col sm={12} md={4} className="Filters-toggle-title">
              <h5>Filtra per:</h5>
            </Col>

            <Col sm={6} md={4}>
              <MenuFilter
                label="Professione"
                dictUrl={makeDictUrl('prof')}
                values={U.extract_multilevel(filters, 'prof')}
                onChange={U.multilevel_updater(onUpdate, 'prof')}
                isSingleSelect={isSingleSelect['prof']}
              />
            </Col>

            <Col sm={6} md={4}>
              <MenuFilter
                label="Territorio"
                dictUrl={makeDictUrl('terr')}
                values={U.extract_multilevel(filters, 'terr')}
                onChange={U.multilevel_updater(onUpdate, 'terr')}
                isSingleSelect={isSingleSelect['terr']}
              />
            </Col>
          </Row>

          <Row className="Filters-menu">
            <Col sm={6} md={4} mdOffset={4}>
              <MenuFilter
                label="Settore ATECO"
                dictUrl={makeDictUrl('sett')}
                values={U.extract_multilevel(filters, 'sett')}
                onChange={U.multilevel_updater(onUpdate, 'sett')}
                isSingleSelect={isSingleSelect['sett']}
              />
            </Col>

            <Col sm={6} md={4}>
              <MenuFilter
                label="Contratto"
                dictUrl={makeDictUrl('contr')}
                values={U.extract_multilevel(filters, 'contr')}
                onChange={U.multilevel_updater(onUpdate, 'contr')}
              />
            </Col>
          </Row>

          <Row className="Filters-toggle">
            <Col sm={12} md={4} className="Filters-toggle-title">
              <h5>Dividi i risultati per:</h5>
            </Col>

            <Col sm={6} md={4}>
              <ToggleFilter
                label="Genere"
                value={filters.gen}
                onChange={(gen) => onUpdate(U.set({ gen, ita: false }), R.identity)}
              />
            </Col>

            <Col sm={6} md={4}>
              <ToggleFilter
                label="Italiani/stranieri"
                value={filters.ita}
                onChange={(ita) => onUpdate(U.set({ ita, gen: false }), R.identity)}
              />
            </Col>
          </Row>
        </Col>

        <Col md={3} className="filto-cal">
          <YearFilter
            value={[filters.from, filters.to]}
            onChange={([from, to]) => onUpdate(U.set({ from, to }), R.identity)}
            yearBounds={yearBounds}
          />
        </Col>
      </Row>
    </Grid>
  )
}

export default Filters



// WEBPACK FOOTER //
// ./src/filters/Filters.js